/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OptOutGroupRef
 */
export interface OptOutGroupRefOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupRef
   */
  optOutGrpId?: number;
}

export interface OptOutGroupRef extends OptOutGroupRefOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupRef
   */
  optOutGrpId: number;
}

export interface OptOutGroupRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupRef
   */
  optOutGrpId?: number;
  optOutGrpIdIsSet: boolean;
}

transformDatesMap.set("OptOutGroupRef", function (model: OptOutGroupRef) {});

export type OptOutGroupRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  optOutGrpId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OptOutGroupRefMeta: OptOutGroupRefMetaI = {} as OptOutGroupRefMetaI;
OptOutGroupRefMeta = typeMeta("OptOutGroupRef", {
  optOutGrpId: propertyMeta(
    "optOutGrpId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = OptOutGroupRefMeta;

registerMeta(() => {});

export class OptOutGroupRefTracked implements OptOutGroupRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  optOutGrpId__I?: number = undefined;

  get optOutGrpIdIsSet() {
    return this.optOutGrpId !== undefined;
  }
  set optOutGrpIdIsSet(v: boolean) {}
  set optOutGrpId(v: undefined | number) {
    if (v !== undefined) {
      this.optOutGrpId__I = v;
      this.optOutGrpIdIsSet = true;
    } else {
      this.optOutGrpId__I = v || undefined;
      this.optOutGrpIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get optOutGrpId() {
    return this.optOutGrpId__I;
  }
  constructor(config?: OptOutGroupRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.optOutGrpIdIsSet == true && other?.optOutGrpIdIsSet == true)
      return this.optOutGrpId == other.optOutGrpId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.optOutGrpId) {
      this.optOutGrpIdIsSet = true;
    }
  }
  assignFrom(
    config: OptOutGroupRefOptional,
    options?: AssignOptions,
  ): OptOutGroupRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.optOutGrpId &&
      this.optOutGrpIdApplyFilter(optionsRequired.filter)
    ) {
      this.optOutGrpId = config.optOutGrpId;
      if (optionsRequired.unassign) this.optOutGrpIdIsSet = false;
      else this.optOutGrpIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutGroupRefTrackedI {
    const cloned = {} as OptOutGroupRefTrackedI;
    if (
      this.optOutGrpIdIsSetDeep() &&
      this.optOutGrpIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutGrpIdIsSet = true;
      cloned.optOutGrpId = this.optOutGrpId;
    } else {
      //cloned.optOutGrpIdIsSet = false
    }
    if (!isDeleted(this) && !this.optOutGrpIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutGroupRefTrackedI {
    if (!this.optOutGrpIdApplyFilter(filter)) this.optOutGrpIdIsSet = false;

    return this;
  }
  optOutGrpIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupRefMeta.optOutGrpId,
      OptOutGroupRefMeta,
      this.optOutGrpId,
      this,
    );
  }
  optOutGrpIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutGrpIdIsSet && this.optOutGrpIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.optOutGrpIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
